import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState } from "react";
import axios from "axios";

const NewBlog = ({ inputs, title }) => {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [info, setInfo] = useState({});
  const [error, setError] = useState("");

  // Handle text field changes
  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  // Handle image upload
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(selectedFile.type)) {
      setError("Only image files (JPEG, PNG, JPG) are allowed!");
      return;
    }

    setError("");
    setImage(selectedFile);

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const res = await axios.post(
        "https://api.mecdistanceeducation.com/api/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setImageUrl(res.data.imageUrl); // store uploaded image URL
    } catch (err) {
      console.error(err);
      setError("Failed to upload image. Please try again.");
    }
  };

  // Handle form submission
  const handleClick = async (e) => {
    e.preventDefault();

    if (!info.title || !info.content || !info.author) {
      setError("Please fill all required fields.");
      return;
    }

    try {
      const token = localStorage.getItem("access_token");

      // Function to generate slug from title
      const generateSlug = (title) => {
        if (!title) return "";
        // Remove content inside parentheses
        let slug = title.replace(/\(.*?\)/g, "");
        // Replace spaces and special characters with underscores
        slug = slug.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_]/g, "");
        // Convert to lowercase
        slug = slug.toLowerCase();
        // Remove leading/trailing underscores
        slug = slug.replace(/^_+|_+$/g, "");
        return slug;
      };

      const newBlog = {
        title: info.title,
        slug: generateSlug(info.title),
        content: info.content,
        author: info.author,
        seoKeywords: info.seoKeywords
          ? info.seoKeywords.split(",").map((k) => k.trim())
          : [],
        seoDescription: info.seoDescription,
        imageUrl: imageUrl,
      };

      const response = await axios.post(
        "https://api.mecdistanceeducation.com/api/blogs",
        newBlog,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Blog created:", response.data);

      // redirect back to blogs list
      const baseUrl = window.location.origin;
      window.location.href = `${baseUrl}/blogs`;
    } catch (err) {
      console.error(err);
      setError("Failed to save blog. Please try again.");
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {/* Upload Image */}
              <div className="formInput">
                <label htmlFor="file">
                  Upload Blog Image:{" "}
                  <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>

              {image && (
                <p>
                  Selected File: <strong>{image.name}</strong>
                </p>
              )}

              {/* Form Inputs */}
              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    onChange={handleChange}
                    type={input.type}
                    placeholder={input.placeholder}
                    id={input.id}
                  />
                </div>
              ))}

              {error && <p className="error">{error}</p>}

              <button onClick={handleClick}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewBlog;
